<div class="dtffawlogin">
  <div class="mbfs-payoff-quote-spinner">
      <!--Default page to load while waiting for Redirection to Classic-->
      <section class="mbfs-home-hero"  style="background-image: url(/static/assets/img/dtf-assets/images/redesign/mbfs_top_image_and_tint.jpg);">
        <section class="mbfs-home-hero__header">
          <h2 class="mbfs-home-hero__header-subtitle">
          {{ 'LoaderPages.BannerHeader' | translate }}
          </h2>
          <p class="mbfs-home-hero__header-text-demi" *ngIf="!this.serviceErrorOccurred">
            {{ 'LoaderPages.FawLoader' | translate }}
          </p>
          <p class="mbfs-home-hero__header-text-demi" *ngIf="this.serviceErrorOccurred">
            {{this.serviceErrorDesc}}
          </p>

          <!--Spinner-->
          <div class="mbfs-loading-spinner-overlay" *ngIf="!this.serviceErrorOccurred"></div>
          <div class="mbfs-loading-spinner"  *ngIf="!this.serviceErrorOccurred"> </div>
        </section>
      </section>
  </div>
</div>
